import GenericLazyLoadImage from 'components/generic/GenericLazyLoadImage'
import { FlexDiv, H1, P } from 'components/generic/HomePageComponents'
import { CardColumn, CardDiv, CardResponsiveContainer } from './Styled'

// TODO: Should probably clean up this mess sometime.

const Card = ({ image, header, copy }) => (
  <CardDiv paddingLeft={['0px', '10px', '15px']}>
    <GenericLazyLoadImage src={image} width='80px' mt='10px' />
    <H1 fontSize='20px' mb='0px' textAlign='center'>
      {header}
    </H1>
    <P fontSize='19px' mb='5px' mt='0px' textAlign='center' width='80%'>
      {' '}
      {copy}
    </P>
  </CardDiv>
)
const Features = ({ data: { header, subHeader, waveImage, cards } }) => {
  const cardComps =
    cards && cards.length > 0
      ? cards.map(({ image, header, copy }, index) => (
          <Card key={index} image={image} header={header} copy={copy} />
        ))
      : []

  return (
    <FlexDiv flexDirection='column' alignItems='center'>
      <H1 fontWeight='400' fontSize='16px' mb='5px'>
        {header}
      </H1>
      <GenericLazyLoadImage src={waveImage} width='85px' />
      <H1 fontSize='36px' maxWidth={['80vw', '80vw', '700px']} textAlign='center' lineHeight='40px'>
        {subHeader}
      </H1>
      <CardColumn>
        {cardComps.length === 5 && (
          <>
            <CardResponsiveContainer>
              {cardComps[0]}
              {cardComps[1]}
              {cardComps[2]}
            </CardResponsiveContainer>
            <CardResponsiveContainer>
              {cardComps[3]}
              {cardComps[4]}
              {cardComps[5]}
            </CardResponsiveContainer>
          </>
        )}
      </CardColumn>
    </FlexDiv>
  )
}

export default Features
